import type { PublicAppConfig } from "@dropl/shared";

let cached: PublicAppConfig | undefined;

function storedLocaleHeader(): string | null {
  try {
    const v = localStorage.getItem("dropl:lang");

    if (v && /^[a-z]{2,5}$/.test(v)) return v;
    return null;
  } catch { return null; }
}

export async function loadAppConfig(): Promise<PublicAppConfig> {
  if (cached) return cached;
  const headers: Record<string, string> = {};
  const lang = storedLocaleHeader();
  if (lang) headers["Accept-Language"] = lang;
  const res = await fetch("/api/config", { credentials: "same-origin", headers });
  if (!res.ok) {
    throw new Error(`Configuration indisponible (HTTP ${res.status})`);
  }
  const data = (await res.json()) as PublicAppConfig;
  cached = data;
  document.title = data.name;
  document.documentElement.lang = data.defaultLocale;
  return data;
}

export async function reloadAppConfig(): Promise<PublicAppConfig> {
  cached = undefined;
  return loadAppConfig();
}
